/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { usePortfolioTransactionListAdjustmentsTableSuspense } from "gen/endpoints/portfolio-transactions/portfolio-transactions";
import React from "react";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { suppressAutoSizePinnedColumns } from "shared/components/table/data/DataTableUtils";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const HistoricalAllocationsPage: React.FC = () => {
  const { t } = useTranslation(["common", "fees"]);

  const { fundFamilyId, fundFamilyEventId } = useRequiredStringParams();

  const readonlyTable = usePortfolioTransactionListAdjustmentsTableSuspense(
    fundFamilyId,
    {
      is_read_only: true,
      fund_family_event_id: fundFamilyEventId,
    },
  );

  return (
    <PageContent contentWidth="wide" isFullHeight={true}>
      <PageHeader
        backButton={{
          title: t("fees:feeUseBreakdown.allocations.backNav"),
        }}
        title={t("fees:feeUseBreakdown.allocations.title")}
      />
      <PageBody>
        <TableBox isFullWidth={true}>
          <TableBoxHeader>
            <TableBoxTitle>
              {t("fees:feeUseBreakdown.allocations.subtitle")}
            </TableBoxTitle>
            <DataTableBoxActions
              showColControl={false}
              showFullScreen={false}
            />
          </TableBoxHeader>
          <TableBoxBody>
            <DataTable
              suppressStatusBar={true}
              data={readonlyTable.data}
              isLoading={readonlyTable.isFetching}
              getColumnDef={suppressAutoSizePinnedColumns}
            />
          </TableBoxBody>
        </TableBox>
      </PageBody>
    </PageContent>
  );
};
export default HistoricalAllocationsPage;
